// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css'; // Optional: Create this if needed

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <div>Hello, Assessment Web App!</div>
//   </React.StrictMode>
// );



import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);